import { gql } from '@apollo/client'

export default gql`
    fragment AddToCartProductTacticFragment on AddToCartProductTactic {
        checksum
        type
        price {
            currencyCode
            value
            format
            discount {
                currencyCode
                percent
                value
                format
            }
        }
    }
    
`
